import { useIsLoggedIn } from '@emico-hooks/login-token'
import { Trans } from '@lingui/macro'

import styles from './CtaButton.module.scss'
import Button from '../../input/Button'
import paths from '../../paths'
import useHasInCompletedFreeGifts from '../../useHasInCompletedFreeGifts'
import useHasInCompletedVouchers from '../../useHasInCompletedVouchers'

export const CtaButton = () => {
    const isLoggedIn = useIsLoggedIn()
    const hasInCompletedGifts = useHasInCompletedFreeGifts()
    const hasInCompletedVouchers = useHasInCompletedVouchers()

    if (isLoggedIn && !hasInCompletedGifts && !hasInCompletedVouchers) {
        return null
    }

    const btnProps = {
        label: isLoggedIn ? (
            <Trans id="cart.emptyState.continueShoppingButton">
                Continue shopping
            </Trans>
        ) : (
            <Trans id="account.login.headingDefault">
                Login or create an account
            </Trans>
        ),
        path: isLoggedIn ? paths.shopAll : paths.login,
    }

    return (
        <Button
            name="cart.priviliges.cta"
            category="cart.priviliges.cta"
            variant="secondary"
            to={btnProps.path}
            wide
            className={styles.buttonCta}
        >
            {btnProps.label}
        </Button>
    )
}
